import Card from "@mui/material/Card"
import CardHeader from "@mui/material/CardHeader"
import CardContent from "@mui/material/CardContent"
import CardActions from "@mui/material/CardActions"
import IconButton from "@mui/material/IconButton"
import Typography from "@mui/material/Typography"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import { Button, Grid, Stack } from "@mui/material"
import { useState } from "react"
import { Link } from "react-router-dom"
import routes from "../../constants/routes"
import { Box } from "@mui/system"

export default function ProgramFeeCard({ data, noView }) {
  return (
    <Card
      elevation={0}
      sx={{
        justifyContent: "space-between",
        maxHeight: "44vh",
        height: "100%",
        borderRadius: { sm: 8 },
        boxShadow: "10px 10px 74px -37px rgba(0,0,0,0.3)",
        p: { sm: 2 },
      }}
    >
      <CardHeader title={data.programName} />

      <CardContent sx={{ py: 0 }}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Stack
              direction="row"
              alignItems="center"
              style={{ color: "gray" }}
              gap={1}
            >
              Total Fee: ₹{data.totalFee || 0}
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <Stack
              direction="row"
              alignItems="center"
              style={{ color: "gray" }}
              gap={1}
            >
              Total Collected: ₹{data.totalCollected || 0}
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <Stack
              direction="row"
              alignItems="center"
              style={{ color: "gray" }}
              gap={1}
            >
              Total Balance: ₹{data.totalBalance || 0}
            </Stack>
          </Grid>
        </Grid>
      </CardContent>

      {!noView && (
        <CardActions>
          <Link
            style={{ width: "100%" }}
            to={`/accounting/fees/${data.id}`}
          >
            <Button
              variant="contained"
              fullWidth
              sx={{ borderRadius: { sm: 8 } }}
              disableElevation
            >
              View Fee Payments
            </Button>
          </Link>
        </CardActions>
      )}
    </Card>
  )
}
